const initials = "exams/";

export const UPDATE_EXAM = `${initials}UPDATE_EXAM`;
export const UPDATE_FILTER = `${initials}UPDATE_FILTER`;
export const UPDATE_REDUCER = `${initials}UPDATE_REDUCER`;